<template>
  <div class="folded-navigation" v-if="items.length > 0">
    <ul class="folded-navigation--main" ref="listContainer">
      <folded-navigation-item :key="item.name" v-for="item in filteredItems" :item="item"></folded-navigation-item>
    </ul>
  </div>
</template>
<script>
import FoldedNavigationItem from "./FoldedNavigationItem.vue";
import Permission from "@/classes/Permission";
import { EventBus } from "@/EventBus";

export default {
  name: "folded-navigation",
  components: {
    FoldedNavigationItem
  },
  props: {
    items: {}
  },
  data() {
    return {
      overflow: null
    };
  },
  mounted() {
    this.handleVisibility();
    EventBus.$off("compute_folded");
    EventBus.$on("compute_folded", this.handleVisibility);
    window.addEventListener("resize", this.handleVisibility);
    EventBus.$off("compute_folded");
  },
  unmounted() {
    window.removeEventListener("resize", this.handleVisibility);
  },
  computed: {
    filteredItems() {
      let permission = Permission.loadPermissions();
      return this.items.filter(function(i) {
        if (!i.credential) {
          return true;
        }
        return Permission.can(permission, i.credential);
      });
    }
  },
  methods: {
    isOverflown(element) {
      if (element) {
        return (
          element.scrollHeight > element.clientHeight ||
          element.scrollWidth > element.clientWidth
        );
      }
    },
    handleVisibility() {
      let elem = this.$refs.listContainer;
      setTimeout(() => {
        this.overflow = this.isOverflown(elem);
        if (!!this.overflow) {
          this.$emit("overflow", this.overflow);
        }
      }, 350);
    }
  },
  watch: {
    $route() {
      this.handleVisibility();
    }
  }
};
</script>
<style lang="scss">
.folded-navigation {
  display: flex;
  flex-basis: 0;
  position: relative;
  overflow: auto;
  width: 100%;

}

.folded-navigation .folded-navigation--main {
  margin: 0;
  padding: 0px 0px 0px 0px;
  list-style-type: none;
  color: $ink-dark;
  display: flex;
  position: relative;
  text-align: left;
  order: 10;
  height: 32px;
}

.folded-navigation--main {
  transition: 250ms all ease-in-out;
  display: flex;
  &.overflow-null,
  &.overflow-true {
    display: none;
    pointer-events: none;
  }
  .folded-navigation-item {
    &:first-child {
      padding-left: 0;
    }

    color: $ink-lighter;
    font-size: 15px;
    font-weight: $font-medium;
    padding: 0px 10px;
    margin-right: 25px;
    transition: 0.15s all ease-out;
    &:hover {
      color: $ink !important;
    }
    &:active {
      color: $ink-dark !important;
    }
  }
  .folded-navigation-item.is-active {
    color: $ink-dark;
    border-bottom: 2px solid $sensual;
  }
}

.folded-navigation-item:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// FoldedNavigation.vue?5cb1dc4e